module.exports = __webpack_public_path__ + "media/src/images/mypage/icon_location-a5abcd65610087a25cdf8557ed5ac27a.png";